import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { InnerLayout } from '../styles/Layouts';
import logo from '../assets/logo.svg';
import bg_footer1 from '../assets/bg_footer1.svg';
import bg_footer2 from '../assets/bg_footer2.svg';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { menuData, about, support } from '../data/menuData';

function Footer() {
  return (
    <FooterStyled>
      <InnerLayout>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: '0.5' }}
        >
          <div className="footer-content">
            <div className="footer-left">
              <div className="logo-content">
                <div className="logo-items">
                  <img src={logo} alt="" />
                  <p>
                    Copyright @2022 IMAFEEL <br />
                    All rights reserved.
                  </p>
                </div>
              </div>
            </div>
            <div className="footer-right">
              <div className="navigation-content">
                <ul className="bottom-nav1">
                  <h4 className="nav-text">Navigation</h4>
                  <div className="links1">
                    {menuData.map((item, index) => {
                      return (
                        <HashLink to={item.link} key={index} className="nav-items">
                          {item.title}
                        </HashLink>
                      );
                    })}
                  </div>
                </ul>
              </div>
              <div className="navigation-content">
                <ul className="bottom-nav1">
                  <h4 className="nav-text">About</h4>
                  <div className="links2">
                    {about.map((item, index) => {
                      return (
                        <HashLink to={item.link} key={index} className="nav-items">
                          {item.title}
                        </HashLink>
                      );
                    })}
                  </div>
                </ul>
              </div>
              <div className="navigation-content">
                <ul className="bottom-nav1">
                  <h4 className="nav-text">Support</h4>
                  <div className="links2">
                    {support.map((item, index) => {
                      return (
                        <NavLink to={item.link} key={index} className="nav-items">
                          {item.title}
                        </NavLink>
                      );
                    })}
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </motion.div>
      </InnerLayout>
    </FooterStyled>
  );
}

const FooterStyled = styled.footer`
  padding: 0 18rem;
  background-image: url(${bg_footer1});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: 70%;

  @media screen and (max-width: 1566px) {
    padding: 0 10rem;
  }
  @media screen and (max-width: 1347px) {
    padding: 0 8rem;
    background-image: url(${bg_footer2});
  }
  @media screen and (max-width: 1186px) {
    padding: 0 6rem;
  }
  @media screen and (max-width: 990px) {
    padding: 0 4rem;
  }
  .footer-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    @media screen and (max-width: 1347px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  .footer-left {
    .logo-content {
      display: flex;
      align-items: center;
      img {
        width: 90px;
      }
    }
  }

  .footer-right {
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 1347px) {
      padding-top: 3rem;
    }
    @media screen and (max-width: 1186px) {
      display: grid;

      justify-content: center;
      align-items: center;
      text-align: center;
      grid-template-columns: repeat(1, 1fr);
    }
  }

  .nav-text {
    padding-bottom: 1rem;
    padding-top: 2rem;
  }
  .footer-bottom {
    padding-top: 3rem;
    .reserved {
      border-top: 2px solid #fff;
    }
  }

  .nav-items {
    padding-top: 0.5rem;
    z-index: 100;
    color: #d6e9ff;
    display: flex;

    transition: all 0.3s ease-in-out;

    @media screen and (max-width: 1186px) {
      display: grid;

      justify-content: center;
      align-items: center;
      text-align: center;
      grid-template-columns: repeat(1, 1fr);
    }
    &:hover {
      color: #fff;
    }
  }
`;

export default Footer;
